import { render, staticRenderFns } from "./design-templates.vue?vue&type=template&id=4b513965&scoped=true&"
import script from "./design-templates.vue?vue&type=script&lang=js&"
export * from "./design-templates.vue?vue&type=script&lang=js&"
import style0 from "./design-templates.vue?vue&type=style&index=0&id=4b513965&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b513965",
  null
  
)

export default component.exports